import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import HeroSection from "./sections/HeroSection";
import HistorySection from "./sections/HistorySection";
import ValuesSection from "./sections/ValuesSection";
import TeamSection from "./sections/TeamSection";
import StatsSection from "./sections/StatsSection";
import ServiceAreasSection from "./sections/ServiceAreasSection";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Header />
      <HeroSection />
      <HistorySection />
      <ValuesSection />
      <TeamSection />
      <StatsSection />
      <ServiceAreasSection />
      <Footer />
    </div>;
}